/**
 * Remembers where an admin was in a list page (query string + scroll position) so
 * "Back to Talent", the sidebar link, and a fresh visit all return to the same spot.
 *
 * Pairs with useSearchParamState (which keeps page/search/sort in the URL): the URL
 * survives the browser Back button; this survives the sidebar click and the
 * "Back" button, which navigate to a bare path.
 *
 * Storage is per-tab (sessionStorage) and every call is fail-soft.
 */
const PREFIX = 'lp:list:'

function store() {
  try { return typeof window !== 'undefined' ? window.sessionStorage : null } catch { return null }
}

export function rememberList(key, { search, scrollY } = {}) {
  const s = store(); if (!s) return
  try {
    const prev = recallList(key) || {}
    const next = {
      search: search !== undefined ? search : prev.search,
      scrollY: scrollY !== undefined ? scrollY : prev.scrollY,
      at: Date.now()
    }
    s.setItem(PREFIX + key, JSON.stringify(next))
  } catch { /* storage full or blocked: ignore */ }
}

export function recallList(key) {
  const s = store(); if (!s) return null
  try {
    const raw = s.getItem(PREFIX + key)
    if (!raw) return null
    const v = JSON.parse(raw)
    return v && typeof v === 'object' ? v : null
  } catch { return null }
}

/** Path to navigate to: the base path plus the remembered query string, if any. */
export function recallListPath(key, basePath) {
  const v = recallList(key)
  const search = v?.search && v.search !== '?' ? v.search : ''
  return basePath + search
}

export function forgetList(key) {
  const s = store(); if (!s) return
  try { s.removeItem(PREFIX + key) } catch { /* ignore */ }
}
